import { type Image, ImageSize } from '@frontend/libs/types/media'
import placeholder from '@images/placeholder-wide.jpg'
import { cn, Image as NextUIImage } from '@nextui-org/react'

export interface ProductImageProps {
  className?: string
  image: Image
  size?: ImageSize
}

export const ProductImage = ({
  className = '',
  image,
  size = ImageSize.Medium,
}: Readonly<ProductImageProps>) => (
  <NextUIImage
    alt={image?.alt || ''}
    className={cn(`aspect-[3/4] h-full w-full ${className}`)}
    fallbackSrc={placeholder}
    removeWrapper
    shadow="none"
    src={image?.sizes[size]}
    srcSet={image?.srcset}
  />
)
